import { WalletPlatform } from "@redotech/redo-customer-portal-shared/utils/wallet-pass";
import { useTranslation } from "@redotech/redo-i18n";
import {
  HAPPY_RETURNS_APPLE_WALLET_BADGE_URL,
  HAPPY_RETURNS_GOOGLE_WALLET_BADGE_URL,
} from "@redotech/redo-return-dropoff-provider-common/happy-returns-assets";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import * as styles from "./happy-returns-wallet-button.module.css";

export interface HappyReturnsWalletButtonProps {
  pending?: boolean;
  platform: WalletPlatform.APPLE | WalletPlatform.GOOGLE;
  onClick(): void;
}

export const HappyReturnsWalletButton = memo(function HappyReturnsWalletButton({
  onClick,
  pending,
  platform,
}: HappyReturnsWalletButtonProps) {
  const { t } = useTranslation();
  const isAppleWallet = platform === WalletPlatform.APPLE;
  const label = t("Add to {{wallet}}", {
    wallet: isAppleWallet ? "Apple Wallet" : "Google Wallet",
  });
  const badgeProps = {
    alt: label,
    src: isAppleWallet
      ? HAPPY_RETURNS_APPLE_WALLET_BADGE_URL
      : HAPPY_RETURNS_GOOGLE_WALLET_BADGE_URL,
  };

  return (
    // design-allow: official wallet artwork must be the complete button surface
    <Flex
      align="center"
      alignSelf="center"
      aria-busy={pending}
      aria-label={label}
      as="button"
      bgColor="none"
      borderWidth="none"
      className={styles.button}
      cursor="pointer"
      disabled={pending}
      gap="none"
      justify="center"
      onClick={onClick}
      p="none"
      type="button"
    >
      <Flex
        {...badgeProps}
        as="img"
        className={styles.walletBadge}
        maxW="full"
      />
    </Flex>
  );
});
